import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { STATIC_STRINGS } from "@asez/shared";
import { formatDateTime, handleDownloadCSV } from "../../../utils";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import EditIcon from "@mui/icons-material/Edit";
import LinkIcon from "@mui/icons-material/Link";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import Tooltip from "@mui/material/Tooltip";
import useMediaQueryScreen from "../../../hooks/useMediaQueryScreen";

const RenderHeader = ({
  data,
  assessmentId,
  reportData,
  visibleColumns,
}: any) => {
  const navigate = useNavigate();
  const { screen, screenProps } = useMediaQueryScreen();
  const columnKeyMappings: Record<string, string> = {
    addedOn: "createdAt",
    attemptedOn: "updatedAt",
    areasOfImprovement: "weakAreas",
    totalMarks: "scorePercentage",
  };

  const mappedVisibleColumns = visibleColumns.map((col) => ({
    key: columnKeyMappings[col.key] || col.key,
    label: col.label,
  }));

  const handleDownload = () => {
    handleDownloadCSV(reportData, mappedVisibleColumns);
  };

  return (
    <div className=" report-header-container">
      <div className="col-12 pb-4">
        <button
          className="cursor-pointer text-neutral-dark p-1 font-medium"
          onClick={() => navigate(-1)}
        >
          <ArrowBackIcon /> {STATIC_STRINGS.BACK}
        </button>
      </div>
      <div className="footer col-12"></div>
      <div className="col-12 row justify-center items-center">
        <div className="col-12 max-w-[1302px] row p-4">
          <div className="col-4 lg:col-6 row py-4">
            <div className="col-12 text-2xl lg:text-4xl font-bold">
              {data.name}
            </div>
            <div className="col-12">
              <div className="text-sm lg:text-lg font-medium text-textColor-subtitle flex items-center">
                <AccessTimeIcon
                  fontSize={!screenProps.is_largeplus ? "small" : "medium"}
                />
                {formatDateTime(data.assessmentLinkActiveDuration.startTime)} -
                {formatDateTime(data.assessmentLinkActiveDuration.endTime)}
              </div>
            </div>
          </div>
          <div className="col-8 lg:col-6 row gap-4 justify-end py-4 items-center">
            <Tooltip title={STATIC_STRINGS.TOOLTIP_MESSAGES.DOWNLOAD_REPORT}>
              <button
                className="btn btn-primary button-padding p-1 flex items-center justify-center "
                onClick={handleDownload}
              >
                <FileDownloadIcon
                  fontSize={!screenProps.is_largeplus ? "small" : "medium"}
                />
              </button>
            </Tooltip>
            <Tooltip title={STATIC_STRINGS.TOOLTIP_MESSAGES.ADD_CANDIDATES}>
              <button
                className="btn btn-outline button-padding p-1 flex items-center justify-center text-neutral-dark"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/edit/${assessmentId}?step=5`);
                }}
              >
                <PersonAddAltIcon
                  fontSize={!screenProps.is_largeplus ? "small" : "medium"}
                />
              </button>
            </Tooltip>
            <Tooltip title={STATIC_STRINGS.TOOLTIP_MESSAGES.EDIT_ASSESSMENT}>
              <button
                className="btn btn-outline button-padding p-1 flex items-center justify-center text-neutral-dark"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/edit/${assessmentId}`);
                }}
              >
                <EditIcon
                  fontSize={!screenProps.is_largeplus ? "small" : "medium"}
                />
              </button>
            </Tooltip>
            <Tooltip
              title={STATIC_STRINGS.TOOLTIP_MESSAGES.COPY_ASSESSMENT_LINK}
            >
              <button className="btn btn-outline button-padding p-1 flex items-center justify-center text-neutral-dark">
                <LinkIcon
                  fontSize={!screenProps.is_largeplus ? "small" : "medium"}
                />
              </button>
            </Tooltip>
            {/* + tooltip */}
            <button className="btn btn-outline h-8 w-32 xl:h-10 xl:w-36 p-1 flex items-center justify-center text-neutral-dark">
              <TimerOutlinedIcon
                fontSize={!screenProps.is_largeplus ? "small" : "medium"}
                className="mr-1"
              />
              <span className="text-sm xl:text-base">
                { STATIC_STRINGS.COMPLETED }
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RenderHeader;
